import { render } from "./MenuList.vue?vue&type=template&id=52ce4f36"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ernes\\.ssh\\bipay-laravel-reportes\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MenuList.vue"]])

export default __exports__